import React, {useEffect, useState} from 'react';
import { MdSearch, MdHouse, MdShoppingBag, MdDelete} from 'react-icons/md';

function ReceiptItem({image, name, size, price, quantity}){

   return(
    <div className='flex width-100 navbar border-bottom cart-item'>
       <div className='flex one center'>
         <img src={image} className='car-img' id="car-img" ></img>
       </div>
       <div className='flex one column'>
        <div className='flex one center-align'>
            <div className='flex one center-align'>
                 <span className='bold small-txt'>item</span>
            </div>
            <div className='flex one center'>
                {name}
            </div>
        </div>
         <div className='flex one center'>
            <div className='flex one center-align'>
                <span className='small-txt bold'>Size:</span>
            </div>
            <div className='flex one center'>
                <span className='small-txt bold'>{size}</span>
            </div>
         </div>
          <div className='flex one center'>
            <div className='flex one center-align'>
                <span className='small-txt bold'>Price</span>
            </div>
            <div className='flex one center'>
                <span className='small-txt bold'>{price} ZMW</span>
            </div>
          </div>
       </div>
       <div className='flex one column'>
        <div className='flex one'></div>
        <div className='flex one center'>
            <span>{quantity}</span>
        </div>
       </div>
    </div>
   )
}

export default ReceiptItem